export const WaCardSkeleton = () => (
    <div className="rounded-2xl p-4 border border-slate-800/50 bg-slate-900/40 animate-pulse">
        <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-slate-700/40" />
                <div className="space-y-2">
                    <div className="w-24 h-4 rounded bg-slate-700/40" />
                    <div className="w-32 h-3 rounded bg-slate-700/30" />
                </div>
            </div>
            <div className="w-16 h-6 rounded-full bg-slate-700/40" />
        </div>
        <div className="grid grid-cols-4 gap-2">
            <div className="h-9 rounded-xl bg-slate-700/30" />
            <div className="h-9 rounded-xl bg-slate-700/30" />
            <div className="h-9 rounded-xl bg-slate-700/30" />
            <div className="h-9 rounded-xl bg-slate-700/30" />
        </div>
    </div>
);